import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { SystemSection } from '../components/SystemSection';
import { BonusSection } from '../components/BonusSection';
import { OfferSection } from '../components/OfferSection';
import { AboutSection } from '../components/AboutSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function LandingPage() {
  return <main className="overflow-hidden bg-background text-foreground min-h-screen font-body" data-id="element-300">
      <HeroSection data-id="element-301" />
      <ForWhoSection data-id="element-302" />
      <PainSection data-id="element-303" />
      <BenefitsSection data-id="element-304" />
      <ProtocolSection data-id="element-305" />
      <TestimonialsSection data-id="element-306" />
      <SystemSection data-id="element-307" />
      <BonusSection data-id="element-308" />
      <OfferSection data-id="element-309" />
      <AboutSection data-id="element-310" />
      <FAQSection data-id="element-311" />
      <FinalCTASection data-id="element-312" />
    </main>;
}